let image: HTMLImageElement | null = null;

export const getEmptyImage = () => {
    if (image) return image;
    image = new Image();
    image.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAAD5Ip3+AAAADUlEQVQIHWNYf2LqfwAHQgMMxZTUcAAAAABJRU5ErkJggg==";
    return image;
};
